import { useLocation } from "react-router-dom";
import { ROUTES } from "@/constants";

/**
 * Resolves the list path for a CMS section under the current backoffice tree.
 */
export function useCmsSectionPath(section: string): string {
  const { pathname } = useLocation();
  const base = pathname.startsWith(ROUTES.backoffice.manager)
    ? ROUTES.backoffice.manager
    : pathname.startsWith(ROUTES.backoffice.moderar)
      ? ROUTES.backoffice.moderar
      : ROUTES.backoffice.admin;

  return `${base}/${section}`;
}
